import { Component, NgModule, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { AppConfigService } from 'src/app/shared/service/app-config.service';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-login-dlg',
  templateUrl: './login-dlg.component.html',
  styleUrls: ['./login-dlg.component.scss'],
})
export class LoginDlgComponent extends BaseComponent implements OnInit {
  Langue: any;
  selectLangue: any;
  langueBooleanCN: boolean;
  langueBooleanVN: boolean;
  langueBooleanTW: boolean;
  langueBooleanEN: boolean;
  languageItems: any;
  validateForm: FormGroup;
  Announcementlist: any;
  DownLoadFlag: string;
  Intranetdsata: any;
  isShowinfo = false;
  isShowinfo1 = false;
  listtimedata: any;
  nzActive = true;
  isVisible = false;
  isVisiblewindow = false;
  window: any;
  userName: string;
  isLoading = false;

  constructor(
    private auth: AuthService,
    private translateService: TranslateService,
    private ConfigService: AppConfigService,
    private translate: TranslateService,
    private Environment: EnvironmentconfigService,
    private webApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private fb: FormBuilder
  ) {
    super();
    this.translate.onLangChange.subscribe(() => { });
  }

  ngOnInit(): void {
    this.window = '各廠聯係窗口';
    this.languageItems = this.ConfigService.getActualConfig('language');
    this.getLangLabel();
    this.switLanguage(this.selectLangue);
    this.getannouncement();
  }

  ngModelChange() { }

  loginEvent() {
    this.auth.clearSwitched();
    this.auth.clearLoginUser();
    this.isLoading = true;
    this.auth.login();
  }

  shoumodal() {
    this.isVisiblewindow = true;
  }

  // 切换语言
  switLanguage(languevalue: any) {
    if (languevalue == '简体中文') {
      languevalue = 'zh-CN';
    }
    if (languevalue == '繁體中文') {
      languevalue = 'zh-TW';
    }
    if (languevalue == 'English') {
      languevalue = 'en';
    }
    if (languevalue == 'Tiếng Việt Nam') {
      languevalue = 'VN';
    }

    localStorage.setItem('wmsmlang', languevalue);
    this.translateService.use(languevalue);
    this.getLangLabel();
    this.getannouncement();
  }

  // this.authService.userInfo.lang
  getLangLabel() {
    const lang = this.languageItems.find(
      (item) =>
        item.value ==
        (localStorage.getItem('wmsmlang') == undefined ||
          localStorage.getItem('wmsmlang') == 'undefined'
          ? 'zh-TW'
          : localStorage.getItem('wmsmlang'))
    );
    if (lang) {
      this.selectLangue = lang.lable;
    }
  }

  getannouncement() {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetNoticeList.url}?type=1`;
    const params = {};
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        const language = localStorage.getItem('wmsmlang');
        this.langueBooleanCN = false;
        this.langueBooleanTW = false;
        this.langueBooleanVN = false;
        this.langueBooleanEN = false;
        if (language == 'zh-CN') {
          this.langueBooleanCN = true;
        } else if (language == 'zh-TW') {
          this.langueBooleanTW = true;
        } else if (language == 'en') {
          this.langueBooleanEN = true;
        } else if (language == 'VN') {
          this.langueBooleanVN = true;
        }
        this.listtimedata = res.data;
      },
      (error) => {
        console.error('Error fetching announcements:', error);
      }
    );
  }

  showModal(value): void {
    this.validateForm = this.fb.group({});
    this.isVisible = true;
  }

  handleOk1(): void {
    this.isVisible = false;
  }

  handleCancel1(): void {
    this.isVisible = false;
  }

  handleOkwindow(): void {
    this.isVisiblewindow = false;
  }

  handleCancelwindow(): void {
    this.isVisiblewindow = false;
  }
}
